import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    IconButton,
    Tooltip,
    Snackbar,
    CircularProgress
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Translate } from '../../../../shared/LanguageService';

interface LinkModalProps {
    open: boolean;
    onClose: () => void;
    link: string;
}

const CopyLinkModal: React.FC<LinkModalProps> = ({ open, onClose, link }) => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setSnackbarOpen(true);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <>
            <Modal open={open} onClose={onClose} aria-labelledby="link-modal-title">
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: {
                            xs: '90vw',
                            sm: 400,
                            md: 500
                        },
                        bgcolor: '#fff',
                        border: '1px solid #dee2e6',
                        borderRadius: '0.3rem',
                        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                        p: 3
                    }}
                >
                    <Typography id="link-modal-title" variant="h6" gutterBottom>
                        {Translate('image-processing/deliver/link-modal/header')}
                    </Typography>

                    {!Boolean(link) ? (
                        <Box display="flex" justifyContent="center" mt={2} mb={2}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                px: 2,
                                py: 1,
                                flexWrap: 'wrap',
                                gap: 1
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: 'calc(100% - 40px)'
                                }}
                            >
                                {link}
                            </Typography>
                            <Tooltip title={Translate('image-processing/deliver/copy-tooltip')}>
                                <IconButton onClick={handleCopy} size="small">
                                    <ContentCopyIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                    <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button onClick={onClose}>{Translate('close')}</Button>
                    </Box>
                </Box>
            </Modal>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                message={Translate('image-processing/deliver/successful-copy-snackbar')}
            />
        </>
    );
};

export default CopyLinkModal;
